// One modal notice for messages the reader must acknowledge before carrying on:
// a share link that did not open, a selection that was refused, an input over the
// size budget. Shared by the comparison page and /parquet-viewer so they look and
// behave the same. Progress ("Reading file…") is NOT a notice and stays inline.
//
// Native <dialog> + showModal: focus moves into it, Escape closes it, and the page
// behind is inert until it is dismissed. jsdom has no showModal, hence `open`.
// Title and message are set with textContent — a message can carry a file or part
// name, which is user data and must never reach innerHTML.

let dialog = null;

function build() {
  dialog = document.createElement('dialog');
  dialog.className = 'notice-dialog';
  dialog.id = 'noticeDialog';
  dialog.setAttribute('aria-labelledby', 'noticeDialogTitle');
  dialog.setAttribute('aria-describedby', 'noticeDialogBody');
  dialog.innerHTML = `
    <div class="notice-dialog-body">
      <h2 id="noticeDialogTitle"></h2>
      <p id="noticeDialogBody"></p>
      <button type="button" class="cta" id="noticeDialogOk">OK</button>
    </div>`;
  dialog.querySelector('#noticeDialogOk').addEventListener('click', closeNotice);
  // The padding lives on the inner wrapper, so a click that lands on the <dialog>
  // itself can only be the backdrop.
  dialog.addEventListener('click', (e) => { if (e.target === dialog) closeNotice(); });
  document.body.append(dialog);
}

/** Show (or, if one is already up, replace) the notice. */
export function showNotice({ title, message }) {
  if (!dialog || !dialog.isConnected) build();
  dialog.querySelector('#noticeDialogTitle').textContent = title;
  dialog.querySelector('#noticeDialogBody').textContent = message;
  if (dialog.open) return dialog;
  if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
  return dialog;
}

export function closeNotice() {
  if (!dialog?.open) return;
  if (dialog.close) dialog.close(); else dialog.removeAttribute('open');
}
